var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { MODAL_TRANSITION_DURATION } from '@connectrn/ds-ui-base';
import { commonAttrs } from '../../utils';
import { CFModalSkinElements } from './ModalSkin.styles';
import { useCFModal } from '../../providers';
export const CFModalSkin = (_a) => {
    var { alternateTheme, children, footerSafeGap, headerSafeGap, heightPreset = 'auto', size = 'md', skin = 'pop' } = _a, rest = __rest(_a, ["alternateTheme", "children", "footerSafeGap", "headerSafeGap", "heightPreset", "size", "skin"]);
    const { Root, Sheet } = CFModalSkinElements;
    const [active, setActive] = useState(false);
    const { footerSafeGap: providerFooterSafeGap, headerSafeGap: providerHeaderSafeGap, } = useCFModal();
    const rootProps = Object.assign({ footerSafeGap: footerSafeGap !== null && footerSafeGap !== void 0 ? footerSafeGap : providerFooterSafeGap, headerSafeGap: headerSafeGap !== null && headerSafeGap !== void 0 ? headerSafeGap : providerHeaderSafeGap, heightPreset,
        size,
        skin }, commonAttrs(rest));
    const sheetProps = {
        alternateTheme,
        footerSafeGap,
        heightPreset,
        skin,
    };
    useEffect(() => setActive(true), []);
    return (React.createElement(CSSTransition, { in: active, timeout: MODAL_TRANSITION_DURATION }, (state) => (React.createElement(Root, Object.assign({ transitionState: state }, rootProps),
        React.createElement(Sheet, Object.assign({}, sheetProps), children)))));
};
